import { __assign, __rest } from "tslib";
import React from "react";
import { View } from "../_core/components";
import classNames from "classnames";
import { useConfig } from "../_util/use-config";
export function Backdrop(_a) {
    var visible = _a.visible, className = _a.className, transparent = _a.transparent, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["visible", "className", "transparent", "onClick", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({}, props, { className: classNames(classPrefix + "-backdrop", className, {
            "is-shown": visible,
            transparent: transparent,
        }) }),
        React.createElement(View, { className: classPrefix + "-backdrop__overlay", onClick: onClick, style: style })));
}
//# sourceMappingURL=Backdrop.js.map